// extracted by mini-css-extract-plugin
export default {"title":"iframe-caspeco-block-module--title--dece7"};